// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3Sk1X","buttons":"SendReceipts_buttons__3ieh5","email":"SendReceipts_email__po3_O","bookApptTitle":"SendReceipts_bookApptTitle__21EGg"};